export const GET_LIST_BANHANGTRAGOP = "GET_LIST_BANHANGTRAGOP";
export const GET_LIST_BANHANGTRAGOP_SUCCESS = "GET_LIST_BANHANGTRAGOP_SUCCESS";
export const GET_LIST_BANHANGTRAGOP_FAILURE = "GET_LIST_BANHANGTRAGOP_FAILURE";
